import { resetSelect } from './modules/selects_helper';
import { fillterCollapse } from './modules/collapse_fillter';
import debounce from './modules/debounce';

function submitForm(filterForm) {
  filterForm.submit();
}

$(() => {
  const filterForm = $('#filter_form');
  const modelSelect = $('.listing-model-select');

  $('#reset, #reset-filters-mobile').on('click', () => {
    const chosenSingleSelects = $('.chosen-single-select');
    const chosenMultiSelects = $('.chosen-multi-select');
    const nonlinearSliders = $('.nonlinear');
    const yearNonlinearSliders = $('.year-nonlinear');

    // Reset form
    chosenSingleSelects.val('').trigger('chosen:updated');
    chosenMultiSelects.val([]).trigger('chosen:updated');
    chosenSingleSelects.closest('.mobile-animate-wrapp').removeClass('filled');
    chosenMultiSelects.closest('.mobile-animate-wrapp').removeClass('filled');
    $('#start-date').val('').datepicker('update');
    $('#end-date').val('').datepicker('update');

    $.each(nonlinearSliders, (index, value) => {
      const defaultRange = value.noUiSlider.options.range;
      const values = $.merge(defaultRange.min, defaultRange.max);
      value.noUiSlider.set(values);
    });

    $.each(yearNonlinearSliders, (index, value) => {
      const defaultRange = value.noUiSlider.options.range;
      const values = $.merge(defaultRange.min, defaultRange.max);
      value.noUiSlider.set(values);
    });

    $(".radio_buttons:input[value='']").prop('checked', true).change();
    $('input:checkbox').prop('checked', false);
    resetSelect(modelSelect);

    filterForm.submit();
  });

  $('.advanced-filter-btn').on('click', function () {
    $(this).find('[class*="angle"]').toggleClass('fa-angle-down fa-angle-up');
    $('.advanced-filter-wrapper').slideToggle();
  });

  const filterContainer = $('.filter-ads');

  $('.toggle-btn').on('click', () => {
    if (filterContainer.hasClass('hide')) {
      filterContainer.removeClass('hide');
      $('.filter-btn').addClass('hide');
      $('.close-button').removeClass('hide');
    } else {
      filterContainer.addClass('hide');
      $('.filter-btn').removeClass('hide');
      $('.close-button').addClass('hide');
    }

    // filterContainer.removeClass('hide');
    // filterContainer.slideDown();brown
    // $(this).slideUp();
  });

  $('.close-filter').on('click', () => {
    filterContainer.slideUp();

    $('html, body').animate({
      scrollTop: 0,
    }, 1000);

    $('.open-filter').slideDown();
  });

  $(window).on('resize', () => {
    if (window.innerWidth >= 992) {
      filterContainer.slideDown();
    }

    if (window.innerWidth < 992) {
      filterContainer.addClass('hide');
    }
    if (window.innerWidth > 992) {
      filterContainer.removeClass('hide');
    }
  });

  if (window.innerWidth < 992) {
    filterContainer.addClass('hide');
  } else {
    filterContainer.removeClass('hide');
  }

  filterForm.on('change', debounce(() => submitForm(filterForm), 1000));

  // fillterCollapse(document.querySelector('.filter-collapse'), document.querySelector('.open-filter'), document.querySelector('.close-filter'));
});



// WEBPACK FOOTER //
// ./app/webpacker/src/js/filters.js